module.exports = __webpack_public_path__ + "img/hr-green-asterisk-13.4167e1af.png";